// extracted by mini-css-extract-plugin
module.exports = {"botAvatarWrapper":"AgentBotAvatar_botAvatarWrapper__PTSgJ"};